<base-support-modal [title]="title" [isLoading]="isLoading" [btnOkClass]="'btn-danger'" [btnOkLabel]="'Перенести'" (onOk)="ok()" >
	<p>
		Номер счёта: <span class="badge badge-info">{{invoiceNumber}}</span>
		<br>
		Тариф: <span class="badge badge-info">{{tariffId.toUpperCase()}}</span>
		<br>
		Действителен до: <span class="badge badge-info">{{dateTo | date:"dd.MM.yyyy"}}</span>
	</p>

	<div class="alert alert-warning" *ngIf="recurrentProfile">
		Данный счёт имеет активную подписку №: <span class="badge badge-warning">{{recurrentProfile}}</span>
	</div>

	<div class="js-ul-radio-group">
		<div class="radio">
			<label>
				<input type="radio" [(ngModel)]="mitsFilter" class="js-ul-radio-group-label" value="userSite">
				Сайты пользователя:
			</label>
		</div>

		<div class="form-group">
			<select [(ngModel)]="userSite" class="form-control js-ul-radio-group-input">
				<option *ngFor="let site of sites" value="{{site.url + '.' + site.zoneDomain}}" [disabled]="site.inPaidMode">{{site.url + '.' + site.zoneDomain}}</option>
			</select>
		</div>
	</div>

	<div class="js-ul-radio-group">
		<div class="radio">
			<label>
				<input type="radio" [(ngModel)]="mitsFilter" class="js-ul-radio-group-label" value="anotherSite">
				Другие сайты:
			</label>
		</div>

		<div class="form-group">
			<input type="text" [(ngModel)]="anotherSite" class="form-control js-ul-radio-group-input" [disabled]="mitsFilter!='anotherSite'">
		</div>
	</div>
</base-support-modal>
